import React, {Fragment, useEffect, useState} from 'react';
import {deleteQst, getQrtList, getQstList, getTirList, postQst} from '../resources/services/frontController'
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Fab from "@material-ui/core/Fab";
import {Backspace, Delete, Edit} from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {getTpeRepList} from "../resources/services/questions";
import SpinnerHexagone from "../components/SpinnerHexagone";

const useStyles = makeStyles(theme => ({
    form: {
        width: '100%',
    },

}));

export default function Questionnaires(props) {

    const classes = useStyles();
    const [listeQrt, setListeQrt] = useState([]);
    const [listeQst, setListeQst] = useState([]);
    const [listeTpe, setListeTpe] = useState([]);
    const [qstQrtId, setQstQrtId] = useState('');
    const [libelleQst, setLibelleQst] = useState('');
    const [qstMere, setQstMere] = useState('');
    const [typeQst, setTypeQst] = useState('');
    const [qstFilter, setQstFilter] = useState('0');
    const [isLoading, setIsLoading] = React.useState(true);
    const [qstQcm, setQstQcm] = React.useState(true);

    useEffect(() => {
        Promise.all([
            getQrtList(), getQstList(), getTpeRepList()
        ]).then(responses => {
            setListeQrt(responses[0].data);
            setListeQst(responses[1].data);
            setListeTpe(responses[2].data);
            setIsLoading(false);
        })
    }, []);

    function deleteQstbyId(id) {
        deleteQst(id)
            .then(response => {
                getQstList().then(response => {
                    const data = response.data;
                    setListeQst(data);
                });
            }).catch(function (error) {
            if (error.response.status === 400) {
                alert('Veuillez supprimer la question enfant')
            }
        });
    }

    function postQstbyId() {
        if((libelleQst!='') && (qstQrtId!='') && (typeQst!='')) {
            postQst([libelleQst, qstQrtId, typeQst, qstMere])
                .then(response => {
                    getQstList().then(response => {
                        const data = response.data;
                        setListeQst(data);
                    });
                });
        }
    }

    function addLibelle(event) {
        setLibelleQst(event.target.value);
    }

    function addQrt(event) {
        setQstQrtId(event.target.value);
    }

    function applyFilter(event) {
        setQstFilter(event.target.value);
        console.log(qstFilter)
    }

    function addType(event) {
        setTypeQst(event.target.value);
        if (event.target.value === 4) {
            setQstQcm(false);
        } else {
            setQstQcm(true);
            setQstMere('');
        }
    }

    function addQstMere(event) {
        setQstMere(event.target.value);
    }

    return (
        <SpinnerHexagone isLoading={isLoading}>
            <FormControl id="myform" className={classes.form}>
                <Grid justify='center' container spacing={2}>
                    <Grid item xs={4}>
                        <TextField
                            id="libelle_qst"
                            label="Texte de la question"
                            name='libelle_qst'
                            fullWidth
                            onChange={(e) => addLibelle(e)}
                            value={libelleQst}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            select
                            id="qrt"
                            label="Questionnaire"
                            name="qrt"
                            onChange={(e) => addQrt(e)}
                            value={qstQrtId}
                            fullWidth
                        >
                            {listeQrt.map(qrtRow => <MenuItem value={qrtRow.qrtId}>{qrtRow.qrtLibelle}</MenuItem>)}
                        </TextField>
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            select
                            id="tpe"
                            label="Type de question"
                            name="tpe"
                            onChange={(e) => addType(e)}
                            value={typeQst}
                        >
                            {listeTpe.map(tpeRow => {
                                if (tpeRow.tpeId !== 4) {
                                    return <MenuItem value={tpeRow.tpeId}>{tpeRow.tpeLibelle}</MenuItem>
                                }
                            })
                            }
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <Fab type="submit" size="small" color="primary" aria-label="Add" onClick={() => {
                            postQstbyId();
                        }}> <AddIcon/> </Fab>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            disabled={qstQcm}
                            select
                            id="tpe"
                            label="Question mère"
                            name="tpe"
                            onChange={(e) => addQstMere(e)}
                            value={qstMere}
                            style={{display: 'none'}}
                        >
                            {listeQst.map(qstRow => {
                                if (qstRow.qrt.qrtId === qstQrtId && qstRow.tpe.tpeLibelle === 'note') {
                                    return <MenuItem value={qstRow.qstId}>{qstRow.qstTxt}</MenuItem>
                                }
                            })
                            }
                        </TextField>
                    </Grid>


                </Grid>
            </FormControl>
            <Grid justify='center' container spacing={2} style={{marginTop: '2%'}}>
                <Grid item m={2}>
                    Filtrer par questionnaire :
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        select
                        id="filtre"
                        name="filtre"
                        onChange={(e) => applyFilter(e)}
                        value={qstFilter}
                        fullWidth
                    >
                        <MenuItem value='0'>Aucun Filtre</MenuItem>
                        {listeQrt.map(qrtRow => <MenuItem value={qrtRow.qrtId}>{qrtRow.qrtLibelle}</MenuItem>)}
                    </TextField>
                </Grid>
            </Grid>
            <Paper style={{marginTop: '15px', minHeight: '150px'}}>
                <Table size="small">
                    <TableHead>
                        <TableRow className="text-center">
                            <TableCell component="td" scope="row">ID</TableCell>
                            <TableCell component="td" scope="row">Texte de la question</TableCell>
                            <TableCell component="td" scope="row">Questionnaire</TableCell>
                            <TableCell component="td" scope="row">Type de question</TableCell>
                            <TableCell component="td" scope="row">Question mère</TableCell>
                            {/*<TableCell component="td" scope="row">Ordre</TableCell>*/}
                            <TableCell component="td" scope="row">Supprimer</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listeQst.map(qstRow => {
                                if (qstFilter === '0' || qstFilter === qstRow.qrt.qrtId) {
                                    return (
                                        <TableRow key={qstRow.qstId}>
                                            <TableCell component="td" scope="row">
                                                <IconButton align="left">{qstRow.qstId}</IconButton>
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <IconButton align="left">{qstRow.qstTxt}</IconButton>
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <IconButton align="left">{qstRow.qrt.qrtLibelle}</IconButton>
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <IconButton align="left">{qstRow.tpe.tpeLibelle}</IconButton>
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <IconButton align="left">{qstRow.qstMere}</IconButton>
                                            </TableCell>
                                            {/*<TableCell component="td" scope="row">*/}
                                            {/*    <IconButton align="left">{qstRow.qstOrdre}</IconButton>*/}
                                            {/*</TableCell>*/}
                                            <TableCell component="td" scope="row">
                                                <IconButton align="left" onClick={() => {
                                                    deleteQstbyId(qstRow.qstId);
                                                }}><Delete/></IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            }
                        )
                        }
                    </TableBody>
                </Table>
            </Paper>
        </SpinnerHexagone>
    )
}